import request from '@/utils/request'

export function getUsers (params) {
  return request.get('/users', { params })
}

export function getProfile () {
  return request.get('/users/profile')
}
